// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"e84609e6","5122":"1f3a2121","5912":"aec78970","7136":"fe900d98","8016":"ce157900"}[chunkId] + ".css";
};